<template>
  <div>
    <b-row>
      <b-col sm="12">
        <Select
          title="Cliente"
          field="customer"
          :formName="formName"
          :required="true"
          url="/api/v1/crm/customer/select-all"
          v-model="card.customer"
          nameNewRegister="customerSupplierOrCollaboratorCreate"
          titleNewRegister="Cliente"
          :widthNewRegister="1200"
          :heightNewRegister="250"
        >
          <CustomerSupplierCreate formName="customerSupplierCreate" :_hideSideBar="false" v-model="card.customer" />
        </Select>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <InputText
          title="Descrição"
          field="description"
          :formName="formName"
          :required="false"
          :maxLength="2000"
          :markFormDirty="false"
          v-model="card.description"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-center">
          <Button
            _key="saveCard"
            type="success"
            title="Salvar"
            :disabled="!isFormValid(formName)"
            classIcon="fa-solid fa-floppy-disk"
            size="medium"
            :clicked="save"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import InputText from "@/ui/forms/InputText";
import Select from "@/ui/forms/Select";

import CustomerSupplierCreate from "@/components/modules/shared/customer-supplier/CustomerSupplierCreate.vue";

import Card from "../../models/Card";
import CardService from "../../services/card.service";

import { mapGetters, mapState, mapMutations } from "vuex";

export default {
  name: "CardCreateForm",
  components: { Button, InputText, Select, CustomerSupplierCreate },
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formName: "cardCreateForm",
      card: new Card(),
    };
  },
  computed: {
    ...mapState("user", ["userLogged"]),
    ...mapGetters("validation", ["isFormValid"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "removeLoading"]),
    async save() {
      this.card.frameId = this.$route.params.id;
      this.card.stepId = this.step.id;
      this.card.userId = this.userLogged.user.id;
      try {
        const response = await CardService.create(this.card);
        this.addEvent({
          name: "cardCreated",
          data: {
            id: response.data.content.id,
            frameId: this.card.frameId,
            stepId: this.step.id,
            stepName: this.step.name,
            stepColor: this.step.color,
            customer: this.card.customer,
            customerName: this.card.customer.content,
            description: this.card.description,
            user: null,
            listTag: [],
            totalComment: 0,
            totalChecklist: 0,
            totalChecklistDone: 0,
            totalJob: 0,
            totalRent: 0,
            totalTeam: 0,
          },
        });
      } finally {
        this.removeLoading(["saveCard"]);
      }
    },
  },
};
</script>

